import PropTypes from "prop-types";
import {Avatar, Card, CardContent, Stack, SvgIcon, Typography} from "@mui/material";
import CurrencyDollarIcon from "@heroicons/react/24/solid/CurrencyDollarIcon";

export const OverviewTotalOrdersAmount = (props) => {
    const {sx, value} = props;

    return (
        <Card sx={sx}>
            <CardContent>
                <Stack alignItems="flex-start" direction="row" justifyContent="space-between" spacing={3}>
                    <Stack spacing={1}>
                        <Typography color="text.secondary" variant="overline">
                            Unpaid Invoices
                        </Typography>
                        <Typography variant="h5">{value}</Typography>
                    </Stack>
                    <Avatar
                        sx={{
                            backgroundColor: "error.main",
                            height: 56,
                            width: 56,
                        }}
                    >
                        <SvgIcon>
                            <CurrencyDollarIcon/>
                        </SvgIcon>
                    </Avatar>
                </Stack>
            </CardContent>
        </Card>
    );
};

OverviewTotalOrdersAmount.propTypes = {
    difference: PropTypes.number,
    positive: PropTypes.bool,
    value: PropTypes.string.isRequired,
    sx: PropTypes.object,
};
